module.exports = __webpack_public_path__ + "static/media/flag_yellow_low.8e789a66.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/flag_yellow_low.jpg
// module id = 1070
// module chunks = 0